import { Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useState } from "react";
import { useSelector } from "react-redux";
import { type RootState } from "../../../store";
import { Modal } from "../Modal";
import { UpdateGoal } from "../update-goal";
import { dialogUpdateGoalStyles } from "./dialog-update-goal.styles";
import { wantToAchiveAnswerImages } from "./images";

type Selector = {
  activeLearningPath: RootState["activeLearningPath"];
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (focusId: number) => void;
  currentFocus: number;
};

export const DialogUpdateGoal = ({
  isOpen,
  onClose,
  onConfirm,
  currentFocus,
}: Props) => {
  const classes = dialogUpdateGoalStyles();
  const [newFocus, setNewFocus] = useState<number>(currentFocus);
  const { activeLearningPath } = useSelector<RootState, Selector>((state) => ({
    activeLearningPath: state.activeLearningPath,
  }));

  const renderImage = (image: number) => {
    const { alt, url } = wantToAchiveAnswerImages.get(image);

    return <img alt={alt} src={url} />;
  };

  const onSaveChanges = () => {
    if (newFocus) onConfirm(newFocus);
    else onClose();
  };

  return (
    <Modal
      title=""
      open={isOpen}
      onClose={onClose}
      onConfirm={onSaveChanges}
      cancelButtonText="Cancel"
      confirmButtonText="Save changes"
      actionConfirmDisabled={!activeLearningPath}
      actionsDisabled={false}
      customCssDialogActions={classes.actions}
      variantCancelBtn="text"
      variantConfirmBtn="outlined"
      maxWidth="lg"
      iconConfirmBtn={<ChevronRightIcon />}
    >
      <Typography className={classes.title}>
        Welcome to Fruition! Let&apos;s personalize your experience.
      </Typography>
      <Typography className={classes.subtitle}>
        What do you want to achieve?
      </Typography>
      <UpdateGoal
        answerClass={classes.answer}
        renderImage={renderImage}
        currentFocusId={currentFocus}
        reportSelection={setNewFocus}
      />
    </Modal>
  );
};
